export const RADIO_BUTTON = 'radioButton';
export const CHECKBOX = 'checkbox';

/**
 * Builds the required_fields object to pass as payload for
 * adding item to cart and product price preview.
 */
export const buildMods = modifications =>
  Object.keys(modifications).reduce((acc, curr) => {
    const currentItem = modifications[curr];

    if (['string', 'number'].includes(typeof currentItem)) {
      acc[curr] = [currentItem];
    } else {
      acc[curr] = Object.keys(currentItem).filter(item => currentItem[item]);
    }

    return acc;
  }, {});

/**
 * Determine whether this should be a dropdown
 * or checkbox base on the minQty and maxQty property
 * maxQty > 1 || (minQty === 0 && maxQty > 1) -> checkbox
 * minQty > 0 && maxQty === 1 -> radiobutton
 */
export const getFieldType = (minQty, maxQty) => {
  minQty = parseInt(minQty);
  maxQty = parseInt(maxQty);

  if (minQty > 0 && maxQty === 1) {
    return RADIO_BUTTON;
  }
  // see https://docs.google.com/document/d/1T0_kHuZRaiXkJbWeVvvduwWRZfa7Tmrv2DQMS6UzIxk/edit#
  // max_qty > 1) || (Min_qty === 0, max_qty  => 1
  return CHECKBOX;
};

export const getVariantPrice = price => (price === '0.00' ? '' : price);
